module.exports = __webpack_public_path__ + "media/markers/pier_yel-dfc384f6.svg";